/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/structural_template/canvas_template_clone" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdStructuralTemplateCanvasTemplateCloneCacheKeys } from "./constants";
import type {
  PostEngagementAppGroupIdStructuralTemplateCanvasTemplateCloneProps,
  EngagementAppGroupIdStructuralTemplateCanvasTemplateCloneResult,
} from "./types";

export const postEngagementAppGroupIdStructuralTemplateCanvasTemplateClone = reactQueryMutationAdapter(
  engagementAppGroupIdStructuralTemplateCanvasTemplateCloneCacheKeys,
  ({
    appGroupId,
    templateId,
  }: PostEngagementAppGroupIdStructuralTemplateCanvasTemplateCloneProps): Promise<EngagementAppGroupIdStructuralTemplateCanvasTemplateCloneResult> => {
    return fetch(
      `/engagement/${appGroupId}/structural_template/canvas_template_clone`,
      "POST",
      { template_id: templateId },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
